export default "__VITE_ASSET__DZwbji85__"